/**
 * WB4-CP — Palette explain command bridge (ExplanatoryInline / assistive AI).
 */

import type { WorkbenchFocus } from '@shared/business-workbench/workbench-focus';
import {
  WORKBENCH_EXPLAIN_HANDLER_PREFIX,
  buildExplainPaletteHandlerRef,
} from '@shared/business-workbench/workbench-command-palette-contract';
import type { AssistiveEntityContext } from '../components/workbench/ai/build-assistive-payload';

export const WORKBENCH_PALETTE_EXPLAIN_REQUEST_EVENT =
  'inflomatrix:workbench-palette-explain-request';

export interface WorkbenchPaletteExplainRequest {
  tenantId: string;
  actionId: string;
  actionLabel: string;
  staticReason?: string;
  focus?: WorkbenchFocus;
  entity?: AssistiveEntityContext;
}

export function parseExplainPaletteSourceActionId(
  handlerRef: string | undefined
): string | undefined {
  if (!handlerRef?.startsWith(WORKBENCH_EXPLAIN_HANDLER_PREFIX)) {
    return undefined;
  }
  const source = handlerRef.slice(WORKBENCH_EXPLAIN_HANDLER_PREFIX.length).trim();
  return source.length > 0 ? source : undefined;
}

export function emitWorkbenchPaletteExplainRequest(detail: WorkbenchPaletteExplainRequest): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<WorkbenchPaletteExplainRequest>(WORKBENCH_PALETTE_EXPLAIN_REQUEST_EVENT, {
      detail,
    })
  );
}

export function buildPaletteExplainHandlerRef(sourceActionId: string): string {
  return buildExplainPaletteHandlerRef(sourceActionId);
}
